import "core-js/modules/es.object.keys.js";
import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f9b6fb58"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "videoMain"
};
var _hoisted_2 = {
  key: 0,
  class: "all-main"
};
var _hoisted_3 = {
  class: "main"
};
var _hoisted_4 = {
  class: "left"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "main-detail"
  }, "视频详情", -1
  /* HOISTED */
  );
});

var _hoisted_6 = {
  class: "main-banner"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "main-head"
};
var _hoisted_9 = {
  class: "author"
};
var _hoisted_10 = {
  class: "main-desc"
};
var _hoisted_11 = {
  class: "desc-detaile"
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("播放：");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("次");

var _hoisted_16 = {
  class: "right"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "相关推荐", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$videoDetail$deta, _ctx$videoDetail$deta2, _ctx$videoDetail$deta3, _ctx$videoDetail$deta4, _ctx$videoDetail$deta5, _ctx$videoDetail$deta6, _ctx$videoDetail$deta7, _ctx$videoDetail$deta8, _ctx$videoDetail$deta9, _ctx$videoDetail$deta10, _ctx$videoDetail$deta11, _ctx$videoDetail$deta12, _ctx$videoDetail$deta13, _ctx$videoDetail$deta14, _ctx$videoDetail$deta15, _ctx$videoDetail$deta16, _ctx$videoDetail$deta17, _ctx$videoDetail$deta18, _ctx$videoDetail$deta19, _ctx$videoDetail$deta20, _ctx$videoDetail, _ctx$videoDetail$deta21, _ctx$videoDetail2;

  var _component_el_image = _resolveComponent("el-image");

  var _component_Related = _resolveComponent("Related");

  var _component_Comment = _resolveComponent("Comment");

  var _component_Loading = _resolveComponent("Loading");

  var _directive_thousand = _resolveDirective("thousand");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [Object.keys(_ctx.videoDetail).length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createCommentVNode(" 视频 "), _createElementVNode("div", _hoisted_6, [_createElementVNode("video", {
    src: (_ctx$videoDetail$deta = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta === void 0 ? void 0 : (_ctx$videoDetail$deta2 = _ctx$videoDetail$deta.player) === null || _ctx$videoDetail$deta2 === void 0 ? void 0 : _ctx$videoDetail$deta2.url,
    style: {
      "width": "100%",
      "height": "100%"
    },
    autoplay: "autoplay",
    controls: "controls",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.vedioClick && _ctx.vedioClick.apply(_ctx, arguments);
    }),
    ref: "vedio"
  }, null, 8
  /* PROPS */
  , _hoisted_7)]), _createCommentVNode(" 头像 "), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_image, {
    src: ((_ctx$videoDetail$deta3 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta3 === void 0 ? void 0 : (_ctx$videoDetail$deta4 = _ctx$videoDetail$deta3.info) === null || _ctx$videoDetail$deta4 === void 0 ? void 0 : _ctx$videoDetail$deta4.avatarUrl) || ((_ctx$videoDetail$deta5 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta5 === void 0 ? void 0 : (_ctx$videoDetail$deta6 = _ctx$videoDetail$deta5.info) === null || _ctx$videoDetail$deta6 === void 0 ? void 0 : _ctx$videoDetail$deta6.cover)
  }, null, 8
  /* PROPS */
  , ["src"]), _createElementVNode("p", _hoisted_9, _toDisplayString(((_ctx$videoDetail$deta7 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta7 === void 0 ? void 0 : (_ctx$videoDetail$deta8 = _ctx$videoDetail$deta7.info) === null || _ctx$videoDetail$deta8 === void 0 ? void 0 : _ctx$videoDetail$deta8.artistName) || ((_ctx$videoDetail$deta9 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta9 === void 0 ? void 0 : (_ctx$videoDetail$deta10 = _ctx$videoDetail$deta9.info) === null || _ctx$videoDetail$deta10 === void 0 ? void 0 : _ctx$videoDetail$deta10.creator.nickname)), 1
  /* TEXT */
  )]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [typeof ((_ctx$videoDetail$deta11 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta11 === void 0 ? void 0 : (_ctx$videoDetail$deta12 = _ctx$videoDetail$deta11.info) === null || _ctx$videoDetail$deta12 === void 0 ? void 0 : _ctx$videoDetail$deta12.publishTime) == 'number' ? (_openBlock(), _createElementBlock("span", _hoisted_12, "发布：" + _toDisplayString(_ctx.$filters.formatTime((_ctx$videoDetail$deta13 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta13 === void 0 ? void 0 : (_ctx$videoDetail$deta14 = _ctx$videoDetail$deta13.info) === null || _ctx$videoDetail$deta14 === void 0 ? void 0 : _ctx$videoDetail$deta14.publishTime, "YYYY-DD-MM")), 1
  /* TEXT */
  )) : (_openBlock(), _createElementBlock("span", _hoisted_13, "发布：" + _toDisplayString((_ctx$videoDetail$deta15 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta15 === void 0 ? void 0 : (_ctx$videoDetail$deta16 = _ctx$videoDetail$deta15.info) === null || _ctx$videoDetail$deta16 === void 0 ? void 0 : _ctx$videoDetail$deta16.publishTime), 1
  /* TEXT */
  )), _createElementVNode("span", null, [_hoisted_14, _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(((_ctx$videoDetail$deta17 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta17 === void 0 ? void 0 : (_ctx$videoDetail$deta18 = _ctx$videoDetail$deta17.info) === null || _ctx$videoDetail$deta18 === void 0 ? void 0 : _ctx$videoDetail$deta18.playTime) || ((_ctx$videoDetail$deta19 = _ctx.videoDetail.detail) === null || _ctx$videoDetail$deta19 === void 0 ? void 0 : (_ctx$videoDetail$deta20 = _ctx$videoDetail$deta19.info) === null || _ctx$videoDetail$deta20 === void 0 ? void 0 : _ctx$videoDetail$deta20.playCount)), 1
  /* TEXT */
  )])), [[_directive_thousand]]), _hoisted_15])])])]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createVNode(_component_Related, {
    relatedList: (_ctx$videoDetail = _ctx.videoDetail) === null || _ctx$videoDetail === void 0 ? void 0 : (_ctx$videoDetail$deta21 = _ctx$videoDetail.detail) === null || _ctx$videoDetail$deta21 === void 0 ? void 0 : _ctx$videoDetail$deta21.related
  }, null, 8
  /* PROPS */
  , ["relatedList"])])]), _createVNode(_component_Comment, {
    commentInfo: ((_ctx$videoDetail2 = _ctx.videoDetail) === null || _ctx$videoDetail2 === void 0 ? void 0 : _ctx$videoDetail2.comment) || {},
    pageInfo: _ctx.commentResInfo,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["commentInfo", "pageInfo", "onChangeCurrent"])])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))]);
}